import { render, staticRenderFns } from "./ProductPeriodDetail.vue?vue&type=template&id=87875ace&scoped=true&"
import script from "./ProductPeriodDetail.vue?vue&type=script&lang=js&"
export * from "./ProductPeriodDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87875ace",
  null
  
)

export default component.exports